/** 역할이 낮아졌을 때 저장하지 않은 편집을 내보낼 수 있는 줄. */
import { Dismiss16Regular } from "@fluentui/react-icons";
import { makeStyles, tokens } from "@fluentui/react-components";
import { useState } from "react";
import { FuiButton } from "@/components/fui-control";
import { saveText } from "@/desktop/file-io";
import { planRoleLabel } from "@/features/access/use-plan-access";
import { useProjectStore } from "@/store/project-store";
import { getRoleDemotion, resetRoleDemotion, useRoleDemotion } from "@/features/access/role-demotion";
import { chromeHeaderProps } from "@/shell/chrome-header";

const useStyles = makeStyles({
  bar: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
    flexShrink: 0,
    minHeight: "32px",
    padding: `${tokens.spacingVerticalXXS} ${tokens.spacingHorizontalM}`,
    backgroundColor: tokens.colorNeutralBackground3,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightRegular,
  },
  text: { flex: 1, minWidth: 0 },
});

export function RoleDemotionBanner() {
  const styles = useStyles();
  useRoleDemotion();
  const notice = getRoleDemotion();
  const [busy, setBusy] = useState(false);
  if (!notice) return null;
  return (
    <div className={styles.bar} role="status" {...chromeHeaderProps}>
      <span className={styles.text}>
        권한이 바뀌었습니다: {planRoleLabel(notice.from)} → {planRoleLabel(notice.to)}. 저장하지 않은 편집은 이 화면에 남아 있습니다.
      </span>
      <FuiButton
        appearance="primary"
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          try {
            const project = useProjectStore.getState();
            await saveText(`${project.project.name}.json`, project.exportProject());
          } finally {
            setBusy(false);
          }
        }}
      >
        {busy ? "내보내는 중…" : "내 변경 내보내기"}
      </FuiButton>
      <FuiButton appearance="subtle" icon={<Dismiss16Regular />} aria-label="알림 닫기" onClick={resetRoleDemotion} />
    </div>
  );
}
